var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "nav-items",
    },
    [
      _c(
        "li",
        {
          staticClass: "nav-item nav-item",
        },
        _vm._l(_vm.classRoom, function (item) {
          return _c(
            "div",
            {
              key: item.name,
            },
            [
              item.authorityTag
                ? _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        to: {
                          path: item.path,
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t(item.name)))]
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
      _vm.profile_base.is_enabled_vip_product && _vm.getCanOrderClass
        ? _c(
            "li",
            {
              staticClass: "nav-item dropdown",
            },
            [
              _c(
                "a",
                {
                  staticClass: "nav-link dropdown-toggle",
                  attrs: {
                    href: "javascript:;",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toggleDropdown("startClass")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("bookClass")))]
              ),
              _c(
                "div",
                {
                  staticClass: "dropdown-menu",
                  class: [_vm.state === "startClass" ? " d-block" : "d-none"],
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-sort",
                      class: [_vm.state ? "mt-1" : "mt-5"],
                    },
                    [_vm._v(_vm._s(_vm.$t("book")))]
                  ),
                  _vm._l(_vm.bookLists, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.name,
                      },
                      [
                        item.authorityTag
                          ? _c(
                              "router-link",
                              {
                                staticClass: "dropdown-item",
                                attrs: {
                                  to: {
                                    path: item.path,
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t(item.name)))]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  _vm._l(_vm.setRecordLists, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.name,
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "dropdown-sort",
                          },
                          [_vm._v(_vm._s(_vm.$t("setRecord")))]
                        ),
                        item.authorityTag
                          ? _c(
                              "router-link",
                              {
                                staticClass: "dropdown-item",
                                attrs: {
                                  to: {
                                    path: item.path,
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t(item.name)))]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _c(
        "li",
        {
          staticClass: "nav-item dropdown",
        },
        [
          _c(
            "a",
            {
              staticClass: "nav-link dropdown-toggle",
              attrs: {
                href: "javascript:;",
              },
              on: {
                click: function ($event) {
                  _vm.toggleDropdown("classRecord")
                  _vm.isSubMenuOpenForP21 = false
                  _vm.isSubMenuOpenForR21 = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("classRecord")))]
          ),
          _c(
            "div",
            {
              staticClass: "dropdown-menu",
              class: [_vm.state === "classRecord" ? " d-block" : "d-none"],
            },
            [
              _vm._l(_vm.classRecordLists, function (item) {
                return _c(
                  "div",
                  {
                    key: item.name,
                  },
                  [
                    item.authorityTag && item.name !== "learnRecords"
                      ? _c(
                          "router-link",
                          {
                            staticClass: "dropdown-item",
                            attrs: {
                              to: {
                                path: item.path,
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t(item.name)))]
                        )
                      : _vm._e(),
                    item.authorityTag && item.name === "learnRecords"
                      ? _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            attrs: {
                              href: `${_vm.newJrUrl}${item.path}`,
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t(item.name)))]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _c(
                "li",
                {
                  staticClass: "dropdown-submenu",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item dropdown-toggle",
                      on: {
                        click: _vm.toggleSubMenuForP21,
                      },
                    },
                    [_vm._v("P21音檔")]
                  ),
                  _c(
                    "ul",
                    {
                      staticClass: "dropdown-menu",
                      class: {
                        show: _vm.isSubMenuOpenForP21,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [_vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3)]
                  ),
                ]
              ),
              _c(
                "li",
                {
                  staticClass: "dropdown-submenu",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item dropdown-toggle",
                      on: {
                        click: _vm.toggleSubMenuForR21,
                      },
                    },
                    [_vm._v("R21音檔")]
                  ),
                  _c(
                    "ul",
                    {
                      staticClass: "dropdown-menu",
                      class: {
                        show: _vm.isSubMenuOpenForR21,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _vm._m(4),
                      _vm._m(5),
                      _vm._m(6),
                      _vm._m(7),
                      _vm._m(8),
                      _vm._m(9),
                    ]
                  ),
                ]
              ),
              _vm._m(10),
            ],
            2
          ),
        ]
      ),
      _c(
        "li",
        {
          staticClass: "nav-item",
        },
        _vm._l(_vm.mgm, function (item) {
          return _c(
            "div",
            {
              key: item.name,
            },
            [
              item.authorityTag
                ? _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        to: {
                          path: item.path,
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t(item.name)))]
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "li",
        {
          staticClass: "nav-item",
        },
        _vm._l(_vm.guide, function (item) {
          return _c(
            "div",
            {
              key: item.name,
            },
            [
              item.authorityTag
                ? _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        to: {
                          path: item.path,
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t(item.name)))]
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("li", [
      _c(
        "a",
        {
          staticClass: "dropdown-item",
          attrs: {
            href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B1LIO",
            target: "_blank",
          },
        },
        [_vm._v("B1")]
      ),
    ])
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("li", [
      _c(
        "a",
        {
          staticClass: "dropdown-item",
          attrs: {
            href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B2LIO",
            target: "_blank",
          },
        },
        [_vm._v("B2")]
      ),
    ])
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("li", [
      _c(
        "a",
        {
          staticClass: "dropdown-item",
          attrs: {
            href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B3LIO",
            target: "_blank",
          },
        },
        [_vm._v("B3")]
      ),
    ])
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("li", [
      _c(
        "a",
        {
          staticClass: "dropdown-item",
          attrs: {
            href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B4LIO",
            target: "_blank",
          },
        },
        [_vm._v("B4")]
      ),
    ])
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("li", [
      _c(
        "a",
        {
          staticClass: "dropdown-item",
          attrs: {
            href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B1LIO",
            target: "_blank",
          },
        },
        [_vm._v("B1")]
      ),
    ])
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("li", [
      _c(
        "a",
        {
          staticClass: "dropdown-item",
          attrs: {
            href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B2LIO",
            target: "_blank",
          },
        },
        [_vm._v("B2")]
      ),
    ])
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("li", [
      _c(
        "a",
        {
          staticClass: "dropdown-item",
          attrs: {
            href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B3LIO",
            target: "_blank",
          },
        },
        [_vm._v("B3")]
      ),
    ])
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("li", [
      _c(
        "a",
        {
          staticClass: "dropdown-item",
          attrs: {
            href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B4LIO",
            target: "_blank",
          },
        },
        [_vm._v("B4")]
      ),
    ])
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("li", [
      _c(
        "a",
        {
          staticClass: "dropdown-item",
          attrs: {
            href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B5LIO",
            target: "_blank",
          },
        },
        [_vm._v("B5")]
      ),
    ])
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("li", [
      _c(
        "a",
        {
          staticClass: "dropdown-item",
          attrs: {
            href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B6LIO",
            target: "_blank",
          },
        },
        [_vm._v("B6")]
      ),
    ])
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("div", [
      _c(
        "a",
        {
          staticClass: "dropdown-item",
          attrs: {
            href: "https://www.cavesbooks.com.tw/EC/book_fair.aspx#3191",
            target: "_blank",
          },
        },
        [_vm._v("魔法故事屋")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }